import React, { useState, useEffect } from "react";
import "../Diagnostic/PackageDetail.css";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import IcuHomeImg from "../assets/images/IcuHomeImg.avif";
import Person3OutlinedIcon from "@mui/icons-material/Person3Outlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import { fetchUserAppAPI } from "../utils/api";
import AddAddressModal from "../components/AddAddressModal";

export default function IcuForm() {
  const navigate = useNavigate();

  const [patientName, setPatientName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [visitDate, setVisitDate] = useState("");
  const [visitTime, setVisitTime] = useState("");

  // Address states
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState("work");
  const [showAddressModal, setShowAddressModal] = useState(false);

  // Notification Toast
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "success" });
    }, 3500);
  };

  const fetchUserAddresses = async (userId) => {
    try {
      const response = await fetchUserAppAPI("list-address", {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
      });
      if (
        response &&
        response.status === 200 &&
        Array.isArray(response.result)
      ) {
        setAddresses(response.result);

        const savedSel = localStorage.getItem("selectedAddress");
        let activeAddr = null;
        if (savedSel) {
          try {
            const parsedSel = JSON.parse(savedSel);
            activeAddr = response.result.find(
              (a) => a.address_id === parsedSel.address_id,
            );
          } catch (e) {}
        }
        if (!activeAddr && response.result.length > 0) {
          activeAddr =
            response.result.find((a) => a.address_default == 1) ||
            response.result[0];
        }

        if (activeAddr) {
          setSelectedAddressId(activeAddr.address_id);
        }
      }
    } catch (err) {
      console.error("Error fetching user addresses:", err);
    }
  };

  useEffect(() => {
    // 1. Prefill logged in user info
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const parsed = JSON.parse(userStr);
        const fullName =
          `${parsed.user_first_name || ""} ${parsed.user_last_name || ""}`.trim();
        setPatientName(fullName);
        setPhone(parsed.user_mobile || "");
        setEmail(parsed.user_email || "");
        if (parsed.user_id) {
          fetchUserAddresses(parsed.user_id);
        }
      } catch (e) {
        console.error("Failed to parse user", e);
      }
    }

    const onAddressChange = () => {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        try {
          const parsed = JSON.parse(userStr);
          fetchUserAddresses(parsed.user_id);
        } catch (e) {}
      }
    };

    window.addEventListener("addressChanged", onAddressChange);
    return () => {
      window.removeEventListener("addressChanged", onAddressChange);
    };
  }, []);

  const handleAddAddressSuccess = (newAddress) => {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      try {
        const parsed = JSON.parse(userStr);
        fetchUserAddresses(parsed.user_id);
      } catch (e) {}
    }
    if (newAddress) {
      setSelectedAddressId(newAddress.address_id);
    }
  };

  const handleSelectLocalAddress = (addr) => {
    if (typeof addr === "object") {
      setSelectedAddressId(addr.address_id);
      localStorage.setItem("selectedAddress", JSON.stringify(addr));
    } else {
      setSelectedAddressId(addr);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!patientName.trim()) {
      showToast("Please enter patient name", "warning");
      return;
    }
    if (!phone.trim()) {
      showToast("Please enter phone number", "warning");
      return;
    }
    if (!visitDate) {
      showToast("Please select a visit date", "warning");
      return;
    }
    if (!visitTime) {
      showToast("Please enter visit time", "warning");
      return;
    }

    let addressStr = "";
    if (addresses.length > 0) {
      const found = addresses.find((a) => a.address_id === selectedAddressId);
      if (found) {
        addressStr =
          `${found.address_plot_no || ""} ${found.address_area || ""} ${found.address_city || ""} ${found.address_pincode || ""}`.trim();
      }
    }

    if (!addressStr) {
      if (selectedAddressId === "work") {
        addressStr =
          "15 Corner, Sector 10 Shopping Center Vijay Path Crossing, Madhyam Marg, Mansarovar, Jaipur, Rajasthan 302020";
      } else if (selectedAddressId === "home") {
        addressStr = "45 Shyam Nagar Sodala, Jaipur, Rajasthan 302020";
      } else if (selectedAddressId === "other") {
        addressStr = "80 Ram 200 Feet Road, Jaipur, Rajasthan 302020";
      } else {
        addressStr = "Jaipur, Rajasthan";
      }
    }

    const bookingDetails = {
      patientName,
      phone,
      email,
      visitDate,
      visitTime,
      address: addressStr,
      visitCharge: 500,
      gst: 25,
      totalAmount: 525,
    };

    localStorage.setItem("icuBookingDetails", JSON.stringify(bookingDetails));
    showToast(
      "ICU Booking Details saved! Redirecting to Checkout...",
      "success",
    );
    setTimeout(() => {
      navigate("/icucheckout");
    }, 800);
  };

  return (
    <>
      <Header />

      {/* Toast Notification */}
      {toast.show && (
        <div
          className={`alert alert-${toast.type === "warning" ? "warning" : toast.type === "danger" ? "danger" : "success"} position-fixed top-0 end-0 m-4 shadow-lg`}
          style={{ zIndex: 9999, borderRadius: "10px", minWidth: "300px" }}
        >
          {toast.message}
        </div>
      )}

      <AddAddressModal
        show={showAddressModal}
        onClose={() => setShowAddressModal(false)}
        onSuccess={handleAddAddressSuccess}
      />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <span className="name_p">ICU Setup At Home</span>
          </div>
        </div>
      </div>
      <div className="booking_form_main">
        <div className="container-fluid">
          <div className="inner_booking_form">
            <div className="row">
              <div className="col-md-5">
                <div
                  className="icu-booking-left"
                  style={{
                    backgroundImage: `url(${IcuHomeImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="icu-booking-left-content">
                    <h3>
                      <span>Hospital-grade ICU care,</span> delivered to your
                      door.
                    </h3>
                    <p>
                      Certified nurses, full monitoring setup and doctor-on-call
                      support — all within your home.
                    </p>
                    <div className="icu-feature-left">
                      <div className="feature-left">
                        <Person3OutlinedIcon />
                        <p>
                          Trained Medical <span>Professionals</span>
                        </p>
                      </div>
                      <div className="feature-left">
                        <HotelOutlinedIcon />
                        <p>
                          Complete ICU <span>Equipment Setup</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-7">
                <div className="booking_box patient_info_form icu-booking-page">
                  <div className="form_patient_info">
                    <form onSubmit={handleSubmit}>
                      <div className="row g-3 booking_box">
                        <h3>Patient / Contact Information</h3>
                        <div className="col-12">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Patient Name"
                            value={patientName}
                            onChange={(e) => setPatientName(e.target.value)}
                            required
                          />
                        </div>

                        <div className="col-md-6">
                          <input
                            type="tel"
                            className="form-control"
                            placeholder="Phone Number"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            required
                          />
                        </div>

                        <div className="col-md-6">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>

                        <div className="col-md-6">
                          <input
                            type="date"
                            className="form-control"
                            placeholder="Visit Date"
                            value={visitDate}
                            onChange={(e) => setVisitDate(e.target.value)}
                            required
                          />
                        </div>

                        <div className="col-md-6">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Visit Time (e.g. 10:00 AM)"
                            value={visitTime}
                            onChange={(e) => setVisitTime(e.target.value)}
                            required
                          />
                        </div>
                      </div>

                      <div className="sample_address mt-4">
                        <div className="booking_box">
                          <h3>Patient Address</h3>
                          <div className="samele_add_radio_btn">
                            {addresses.length > 0 ? (
                              addresses.map((addr) => (
                                <label
                                  key={addr.address_id}
                                  className="address_box"
                                >
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={
                                      selectedAddressId === addr.address_id
                                    }
                                    onChange={() =>
                                      handleSelectLocalAddress(addr)
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>
                                      {addr.address_title ||
                                        addr.address_type ||
                                        "Saved Address"}
                                    </h4>
                                    <p>
                                      {addr.address_plot_no} {addr.address_area}{" "}
                                      {addr.address_city} {addr.address_pincode}
                                    </p>
                                  </div>
                                </label>
                              ))
                            ) : (
                              <>
                                <label className="address_box">
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={selectedAddressId === "work"}
                                    onChange={() =>
                                      handleSelectLocalAddress("work")
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>Work Address</h4>
                                    <p>
                                      15 Corner, Sector 10 Shopping Center Vijay
                                      Path Crossing, Madhyam Marg, Mansarovar,
                                      Jaipur, Rajasthan 302020
                                    </p>
                                  </div>
                                </label>

                                <label className="address_box">
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={selectedAddressId === "home"}
                                    onChange={() =>
                                      handleSelectLocalAddress("home")
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>Home Address</h4>
                                    <p>
                                      45 Shyam Nagar Sodala, Jaipur, Rajasthan
                                      302020
                                    </p>
                                  </div>
                                </label>

                                <label className="address_box">
                                  <input
                                    type="radio"
                                    name="address"
                                    checked={selectedAddressId === "other"}
                                    onChange={() =>
                                      handleSelectLocalAddress("other")
                                    }
                                  />
                                  <span className="radio_circle"></span>
                                  <div className="address_content">
                                    <h4>Other Address</h4>
                                    <p>
                                      80 Ram 200 Feet Road, Jaipur, Rajasthan
                                      302020
                                    </p>
                                  </div>
                                </label>
                              </>
                            )}
                          </div>
                          <div className="add_more_btn mt-3">
                            <button
                              type="button"
                              onClick={() => {
                                const userStr = localStorage.getItem("user");
                                if (!userStr) {
                                  showToast(
                                    "Please login first to add a new address.",
                                    "warning",
                                  );
                                  window.dispatchEvent(
                                    new Event("openLoginModal"),
                                  );
                                } else {
                                  setShowAddressModal(true);
                                }
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#056839",
                                fontWeight: "600",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <AddOutlinedIcon /> Add New Address
                            </button>
                          </div>
                        </div>
                        <div className="token-book">
                          <div className="token-money">
                            <p>Visit Token Money</p>
                            <p>₹ 500/-</p>
                          </div>
                          <button type="submit" className="btn-book">
                            Book Now
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
